import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import SectionImageFreeFlow from "apps/website/components/section/SectionImageFreeFlow/SectionImageFreeFlow";
import {
  sectionImageFreeFlowData,
} from "apps/website/components/section/SectionImageFreeFlow/shared/data";

export default function SectionFoundersMessage() {
  return (
    <>
      <SectionImageFreeFlow image={ sectionImageFreeFlowData.image } theme="light-grey">
        <TextTitle tag="h2" align="center" className="uppercase">Because of love, love, love.</TextTitle>
        <Spacer size="lg" />
        <TextBody align="center" whitespace="balance">
          We make every meal for your cat with the same care,
          love and science we want for our own cats.
          And see time and time again how switching to fresh provides
          meaningful and lasting change to cat health and happiness.
        </TextBody>
        <Spacer size="lg" />
        <TextSubtitle tag="h3" size={2} align="center" whitespace="balance">Nikki and Brett, Co-founders of KatKin</TextSubtitle>
        <TextBody size={2} align="center">(and cat parents to Molly, Boo, Kiki and Columbus)</TextBody>
      </SectionImageFreeFlow>
    </>
  );
}
